import styled from 'styled-components';
import BestRatesSvg from '../../../assets/onboarding/newHome/best-rates.svg';

const BestRatesIcon = styled(BestRatesSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '4.4rem'};
height: ${props => props.height || '4.4rem'};
display: flex;
`;

export default BestRatesIcon;
